<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form class="noAlTope" v-on:submit.prevent="buscarPacientePti">
      <b-row>
        <b-col cols="10">
          <b-form-input
            v-model="idPaciente"
            placeholder="Id del paciente"
            :state="idPaciente != null"
            required
          >
          </b-form-input>
          <b-form-invalid-feedback :state="idPaciente != null">
            Debe colocar el Id del paciente
          </b-form-invalid-feedback>
        </b-col>

        <b-col>
          <b-button type="submit" variant="outline-primary"> Buscar </b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-button class="mb-4" variant="primary" disabled v-if="buscando">
      <b-spinner small></b-spinner>
      Cargando...
    </b-button>

    <div v-else>
      <div v-if="!mostrarDatos">
        <b-alert variant="danger" show>No existen datos</b-alert>
      </div>
      <b-table
        :items="datosPtiPaciente"
        :fields="titulos"
        thead-tr-class="columnas"
        responsive
        v-else
      >
        <template v-slot:cell(acciones)="row">
          <div class="alignIcon">
            <b-form-select
              v-model="row.item.nuevoPlan"
              :options="row.item.planPaciente"
              value-field="idPlan"
              text-field="nombrePlan"
            >
            </b-form-select>

            <b-button class="ml-4" variant="primary" disabled v-if="enviando">
              <b-spinner small></b-spinner>
            </b-button>

            <b-button
              class="ml-4"
              variant="outline-primary"
              v-on:click="guardarPlanPti(row.item)"
              v-else
            >
              Guardar
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "PtiPlanPaciente",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    idPaciente: null,
    datosPtiPaciente: [],
    titulos: [
      { key: "nombrePaciente", label: "Nombre del paciente" },
      { key: "idPti", label: "Pti" },
      { key: "acciones", label: "Acciones" },
    ],
    buscando: false,
    enviando: false,
    mostrarDatos: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    buscarPacientePti() {
      this.buscando = true;
      this.datosPtiPaciente = [];

      const url = this.$api + "pti/plan/paciente/" + this.idPaciente;

      this.$http
        .get(url)
        .then((response) => {
          if (response.data.data) {
            if (response.data.data.idPti != null) {
              this.mostrarDatos = true;
              this.datosPtiPaciente.push(response.data.data);
            }
          }
        })
        .catch((err) => {
          this.errorObtener(err);
        })
        .finally(() => {
          this.buscando = false;
        });
    },
    guardarPlanPti(plan) {
      this.enviando = true;
      const parametros = {
        idPti: plan.idPti,
        nuevoPlan: plan.nuevoPlan,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
      };
      const url = this.$api + "pti/planes";

      this.$http
        .put(url, parametros)
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Datos actualizados correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
        })
        .catch((err) => {
          this.errorEnvio(err);
        })
        .finally(() => {
          this.enviando = false;
          this.mostrarDatos = false;
        });
    },
  },
  notifications: {
    errorObtener: {
      type: "error",
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: "error",
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>

<style>
</style>